import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdMonetizationOn,
  MdMoney,
  MdPerson,
  MdHome,
  MdLock,
  MdWater,
  MdOutlineShoppingCart,
  MdWallet,
  MdAssignment
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import NFTMarketplace from 'views/admin/marketplace';
import Profile from 'views/admin/profile';
import DataTables from 'views/admin/dataTables';
import DataTables1 from 'views/admin/dataTables1';
import DataTables2 from 'views/admin/dataTables2';
import DataTables3 from 'views/admin/dataTables3';
import DataTables4 from 'views/admin/dataTables4';
import User from 'views/admin/user';
import RechargeBalance from 'views/admin/rechargeBalance';
import RTL from 'views/admin/rtl';

// Auth Imports
import SignInCentered from 'views/auth/signIn';

const routes = [
  {
    name: '首页',
    layout: '/admin',
    path: '/profile',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component:  <User />,
    secondary: true,
  },
  {
    name: '余额充值',
    layout: '/admin',
    icon: <Icon as={MdWallet} width="20px" height="20px" color="inherit" />,
    path: '/recharge-balance',
    component: <RechargeBalance />,
  },
  {
    name: '充值记录',
    layout: '/admin',
    icon: <Icon as={MdMonetizationOn} width="20px" height="20px" color="inherit" />,
    path: '/data-tables1',
    component: <DataTables1 />,
  },
  // {
  //   name: '提现记录',
  //   layout: '/admin',
  //   icon: <Icon as={MdMoney} width="20px" height="20px" color="inherit" />,
  //   path: '/data-tables2',
  //   component: <DataTables2 />,
  // },
  {
    name: '消费流水',
    layout: '/admin',
    icon: <Icon as={MdWater} width="20px" height="20px" color="inherit" />,
    path: '/data-tables3',
    component: <DataTables3 />,
  },
  {
    name: '开票记录',
    layout: '/admin',
    icon: <Icon as={MdAssignment} width="20px" height="20px" color="inherit" />,
    path: '/data-tables4',
    component: <DataTables4 />,
  },
  // {
  //   name: '个人中心',
  //   layout: '/admin',
  //   icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
  //   path: '/user',
  //   component: <User />,
  // },
  // {
  //   name: 'Main Dashboard',
  //   layout: '/admin',
  //   path: '/default',
  //   icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
  //   component: <MainDashboard />,
  // },
  // {
  //   name: 'NFT Marketplace',
  //   layout: '/admin',
  //   path: '/nft-marketplace',
  //   icon: (
  //     <Icon
  //       as={MdOutlineShoppingCart}
  //       width="20px"
  //       height="20px"
  //       color="inherit"
  //     />
  //   ),
  //   component: <NFTMarketplace />,
  // },
  // {
  //   name: 'Data Tables',
  //   layout: '/admin',
  //   icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
  //   path: '/data-tables',
  //   component: <DataTables />,
  // },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
  },
  // {
  //   name: 'RTL Admin',
  //   layout: '/rtl',
  //   path: '/rtl-default',
  //   icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
  //   component: <RTL />,
  // },
];

export default routes;
